import { parseUnits, formatUnits } from 'viem';

export function tokenAmount(amount, decimals = 18) {
    try {
        if (!amount && amount !== 0 && amount !== 0n) {
            return { parsed: null, formatted: '0', isValid: false };
        }

        // If already a BigInt, just format it
        if (typeof amount === 'bigint') {
            const formatted = formatUnits(amount, decimals); // ✅ human-readable string
            return {
                parsed: amount,   // 💠 parsed = value in WEI (BigInt)
                formatted,        // 💫 formatted = human-readable token amount
                isValid: true
            };
        }

        // Convert to string and handle various input types
        const amountStr = typeof amount === 'number'
            ? amount.toString()
            : String(amount);

        const parsed = parseUnits(amountStr, decimals);   // 💠 parsed = WEI (BigInt)
        const formatted = formatUnits(parsed, decimals);  // 💫 formatted = human-readable string

        return {
            parsed,     // 💠 WEI (BigInt, blockchain amount)
            formatted,  // 💫 human-readable string, e.g., "1.23"
            isValid: true
        };
    } catch (error) {
        console.error('Error processing token amount:', error);
        return { parsed: null, formatted: '0', isValid: false };
    }
}
